<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../../index';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';

export default {
  components: {
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      phoneNumber: '',
      apiToken: '',
      channelId: '',
      webLogin: '',
      webPassword: '',
      webAccessToken: '',
      webRefreshToken: '',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    phoneNumber: { required, isPhoneE164OrEmpty },
    apiToken: { required },
    channelId: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createWazzup24Channel',
          {
            channel: {
              phone_number: this.phoneNumber,
              api_token: this.apiToken,
              channel_id: this.channelId,
              name: this.inboxName,
              web_login: this.webLogin || undefined,
              web_password: this.webPassword || undefined,
              web_access_token: this.webAccessToken || undefined,
              web_refresh_token: this.webRefreshToken || undefined,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
        <input
          v-model="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
          @blur="v$.inboxName.$touch"
        />
        <span v-if="v$.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.phoneNumber.$error }">
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
        <input
          v-model="phoneNumber"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')"
          @blur="v$.phoneNumber.$touch"
        />
        <span v-if="v$.phoneNumber.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.channelId.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.CHANNEL_ID.LABEL') }}
        </span>
        <input
          v-model="channelId"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.CHANNEL_ID.PLACEHOLDER')"
          @blur="v$.channelId.$touch"
        />
        <span v-if="v$.channelId.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.CHANNEL_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label :class="{ error: v$.apiToken.$error }">
        <span>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_TOKEN.LABEL') }}
        </span>
        <input
          v-model="apiToken"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.API_TOKEN.PLACEHOLDER')"
          @blur="v$.apiToken.$touch"
        />
        <span v-if="v$.apiToken.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.API_TOKEN.ERROR') }}
        </span>
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.WEB_LOGIN.LABEL') }}
        <input
          v-model="webLogin"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.WEB_LOGIN.PLACEHOLDER')"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.WEB_PASSWORD.LABEL') }}
        <input
          v-model="webPassword"
          type="password"
          :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.WEB_PASSWORD.PLACEHOLDER')"
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.WEB_ACCESS_TOKEN.LABEL') }}
        <input
          v-model="webAccessToken"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.WEB_ACCESS_TOKEN.PLACEHOLDER')
          "
        />
      </label>
    </div>

    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.WHATSAPP.WEB_REFRESH_TOKEN.LABEL') }}
        <input
          v-model="webRefreshToken"
          type="text"
          :placeholder="
            $t('INBOX_MGMT.ADD.WHATSAPP.WEB_REFRESH_TOKEN.PLACEHOLDER')
          "
        />
      </label>
    </div>

    <div class="w-full mt-4">
      <NextButton
        :is-loading="uiFlags.isCreating"
        type="submit"
        solid
        blue
        :label="$t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>
